
// eslint-disable-next-line import/prefer-default-export
export function isGenderFemaleOrGirl(gendercode) {
  if (gendercode && (gendercode === "F" || gendercode === "G")) {
    return true;
  }
  return false;
}

/**
 * Validates if a given string is valid JSON format
 * Handles null, undefined, non-string values, and various JSON parse errors
 * @param {*} str - The value to validate as JSON
 * @returns {boolean} - True if valid JSON string, false otherwise
 */
export const isValidJson = (str) => {
  // Check for null or undefined values
  if (str === null || str === undefined) {
    return false;
  }

  // Check if the input is a string type
  if (typeof str !== "string") {
    return false;
  }

  // Trim whitespace and check if empty string
  const trimmedStr = str.trim();
  if (trimmedStr === "") {
    return false;
  }

  try {
    const parsed = JSON.parse(trimmedStr);
    // Ensure the parsed result is a valid object or array, not primitive values
    if (parsed === null || (typeof parsed !== "object" && !Array.isArray(parsed))) {
      // JSON.parse can return primitives like true, false, numbers, strings
      // Return true for valid JSON primitives as well
      return true;
    }
    return true;
  } catch (error) {
    // JSON.parse threw an error - invalid JSON format
    return false;
  }
}